import {get} from "../api"
import * as url from "../url"

const apiGetNotificationDropdownRefresh = data => {
  return get(url.API_NOTIFICATIONS + "dropdown-refresh", data.history)
}

export {
  apiGetNotificationDropdownRefresh,
}
